import { atom } from "jotai";

/**
 * Mirrors public.cost_basis_enum / public.consumption_basis_enum. Both enums
 * carry the same members but drive different things: cost_basis is presentation
 * only, consumption_basis changes when stock is marked consumed.
 */
export type BasisType = 'unit_type' | 'stock_type';

export interface ITrackableItem {
    id?: string;
    vendor_id: string;
    stock_type_id: number;
    unit_type_id: number;
    standard_unit_count: number;
    default_zones?: number[] | null;
    stock_count?: number;
    unit_count?: number;
    cost?: number | null;
    cost_basis: BasisType;
    /**
     * Which level consumption happens at.
     *   'unit_type'  — consumed once every unit is depleted (unit_count hits 0)
     *   'stock_type' — the stock item is indivisible; any pick consumes it whole
     */
    consumption_basis: BasisType;
    repurchase_threshold?: number;
    sku?: string | null;
    name: string;
    notes?: string | null;
    audit_group_id?: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface ITrackableItemInput extends Omit<ITrackableItem, 'id' | 'created_at' | 'updated_at'> {}

export const trackableItemsAtom = atom<ITrackableItem[]>([]);
export const trackableItemsLoadingAtom = atom<boolean>(false);

